// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__f6IG-","label":"LabeledBox_label__204zM"};